/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionEndPageMask';

const ActionEndPageMaskManager: ActionManagerFn<'ActionEndPageMask'> = (
  platform: Platform,
): ActionManager<'ActionEndPageMask'> => {
  return {
    ...baseActionManager(platform, 'ActionEndPageMask'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'End Page Mask',
    icon: { iconName: 'spinner', iconType: 'duotone' },
    description: `**Overview**<br/>
The End Page Mask action is the functional counterpart to the Start Page Mask action. Its primary purpose is to terminate the masking state on the user interface, effectively removing any loading indicators or interaction blocks previously active on the page.<br/><br/>
Like its "Start" counterpart, this component is structurally minimal. It relies entirely on the platform's base action architecture for its execution logic and property definitions, serving as a specific signal within the registry to restore user interactivity.

**Key Features**<br/>
* **Standard Inheritance:** Inherits all functionality and behavior directly from baseActionManager and baseActionProps without introducing custom validation or property logic.
* **Configuration Simplicity:** Requires no specific component-level properties, operating purely as a trigger to disable the masking state.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, accepting only the standard configuration options available to all generic actions.

**Use Cases**<br/>
* **Completion Feedback:** Executed at the end of a logic flow (e.g., after an API call or data computation) to remove the loading spinner.
* **Error Handling:** Used within error handling blocks to ensure the UI is unblocked even if a background process fails.`,
  };
};

export default ActionEndPageMaskManager;
